import React from 'react';

const skillGroups = [
  {
    category: "Backend",
    icon: "⚙️",
    skills: ["Java", "Spring Boot", "Microservices", "REST APIs", "Node.js"]
  },
  {
    category: "Frontend & Mobile",
    icon: "🖥️",
    skills: ["React", "React Native", "Next.js", "TypeScript", "JavaScript"]
  },
  {
    category: "Databases",
    icon: "🗄️",
    skills: ["PostgreSQL", "MySQL", "Redis"]
  },
  {
    category: "DevOps & Tools",
    icon: "🛠️",
    skills: ["Docker", "Git", "GitHub", "CI/CD", "Linux"]
  }
];

function Skills() {
  return (
    <div style={styles.container} id="skills-section">
      <h2 style={styles.heading}>Skills</h2>
      <p style={styles.subheading}>Technologies I build production systems with</p>
      <div style={styles.grid}>
        {skillGroups.map((group) => (
          <div key={group.category} style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.icon}>{group.icon}</span>
              <h3 style={styles.category}>{group.category}</h3>
            </div>
            <div style={styles.tagContainer}>
              {group.skills.map((skill) => (
                <span key={skill} style={styles.tag}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginTop: '40px',
    padding: '60px 40px',
    backgroundColor: '#e9f1fb',
  },
  heading: {
    fontSize: '32px',
    color: '#1f2a47',
    marginBottom: '8px',
    textAlign: 'center',
    fontWeight: '700',
  },
  subheading: {
    fontSize: '15px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '40px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '24px',
    maxWidth: '960px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  },
  icon: {
    fontSize: '22px',
  },
  category: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#1e90ff',
    margin: 0,
  },
  tagContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  tag: {
    backgroundColor: '#e9f1fb',
    color: '#1f2a47',
    padding: '6px 14px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '500',
  },
};

export default Skills;